import { render } from "./BarChart.vue?vue&type=template&id=0ba9bacc"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"

import "./BarChart.vue?vue&type=style&index=0&id=0ba9bacc&lang=scss"
script.render = render

export default script